import { systemPropertiesApi } from 'app/services/api';

import { HTTP_RESPONSE_STATUS_CODES } from 'constants/http';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const USER_PROPERTIES_ACTIONS = createNamedActions('userProperties', {
  GET_PROPERTY_DEFINITIONS: 'GET_PROPERTY_DEFINITIONS',
  GET_USER_OVERRIDES: 'GET_USER_OVERRIDES',
  SET_USER_OVERRIDE: 'SET_USER_OVERRIDE',
  DELETE_USER_OVERRIDE: 'DELETE_USER_OVERRIDE',
});

export const getPropertyDefinitionsAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await systemPropertiesApi.getAllPropertyDefinitions();

  return dispatch({
    type: USER_PROPERTIES_ACTIONS.GET_PROPERTY_DEFINITIONS,
    payload: data,
  });
});

const getUserOverridesWithFallback = async params => {
  try {
    return await systemPropertiesApi.getUserOverrides(params);
  } catch (err) {
    if (err?.response?.status === HTTP_RESPONSE_STATUS_CODES.FORBIDDEN) {
      return systemPropertiesApi.getUserOverridesInternal(params);
    }

    throw err;
  }
};

export const getUserOverridesAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await getUserOverridesWithFallback(params);

  return dispatch({
    type: USER_PROPERTIES_ACTIONS.GET_USER_OVERRIDES,
    payload: data,
  });
});

const setUserOverrideWithFallback = async params => {
  try {
    return await systemPropertiesApi.setUserOverride(params);
  } catch (err) {
    if (err?.response?.status === HTTP_RESPONSE_STATUS_CODES.FORBIDDEN) {
      return systemPropertiesApi.setUserOverrideInternal(params);
    }

    throw err;
  }
};

export const setUserOverrideAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await setUserOverrideWithFallback(params);

  return dispatch({
    type: USER_PROPERTIES_ACTIONS.SET_USER_OVERRIDE,
    payload: data,
    meta: params,
  });
});

const deleteUserOverrideWithFallback = async params => {
  try {
    await systemPropertiesApi.deleteUserOverride(params);
  } catch (err) {
    if (err?.response?.status === HTTP_RESPONSE_STATUS_CODES.FORBIDDEN) {
      await systemPropertiesApi.deleteUserOverrideInternal(params);

      return;
    }

    throw err;
  }
};

export const deleteUserOverrideAction = catchAsyncActionError(params => async dispatch => {
  await deleteUserOverrideWithFallback(params);

  return dispatch({
    type: USER_PROPERTIES_ACTIONS.DELETE_USER_OVERRIDE,
    meta: params,
  });
});
